import React, { useState } from "react";
import { Modal, Button,Input } from "antd";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import defaultAvatar from "../../../../assets/images/default-avatar.png";
import "../utils/validate.css";
import {updateKycStatus } from "../services/merchentApi";

const KycMerchent = ({ modal, setModal, toggle, selectedMerchent, mode = "validate",onSuccess }) => {
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const isValidateMode = mode === "validate";
const isKycActive = selectedMerchent?.kycVerified;

const handleAction = async () => {
  if (!selectedMerchent?.id) {
    toast.error("Marchand invalide");
    return;
  }

  const newStatus = !selectedMerchent.kycVerified;

  if (!newStatus && !reason.trim()) {
    toast.error("Le motif de désactivation du kyc est obligatoire");
    return;
  }

  setIsLoadingSubmit(true);

  try {
    await updateKycStatus(
      selectedMerchent.id,
      newStatus,
      newStatus ? "" : reason
    );

    toast.success(
      newStatus
        ? "KYC activé avec succès"
        : "KYC désactivé avec succès"
    );

    if (onSuccess) {
      await onSuccess();
    }

    setModal(false);

  } catch (error) {
  const apiMessage = error?.response?.data?.message;

  if (
    apiMessage?.includes("Au moins un document KYC du merchant est requis")
  ) {
    toast.error("Au moins un document KYC du marchand est requis");
  } else {
    toast.error(apiMessage || error?.message || "Une erreur est survenue");
  }
}
};
const [reason, setReason] = useState("");
  return (
    <Modal
      open={modal}
      onCancel={toggle}
      footer={null}
      centered
     width={450}
      className="modal-validate"
    >
      <div className="validate-modal-content">
        <h2 className="validate-title">
      {isKycActive
        ? `Désactivation du KYC du marchand ? `
        : `Activer du KYC du marchand ? `}
        </h2>
     <div>
      <div className="validate-merchent mb-3">
  {isKycActive ? (
    <>
      <div>
        La désactivation du KYC entraînera la suspension du statut vérifié du marchand sur la plateforme Paxity.
      </div>

      <div style={{ fontWeight: 500 }}>
        À compter de cette action :
      </div>

      <div>• Le marchand ne pourra plus recevoir de nouvelles commandes.</div>
      <div>• Certaines fonctionnalités de son tableau de bord pourront être restreintes.</div>
      <div>• Son compte pourra être temporairement limité jusqu’à régularisation de sa situation.</div>

      <div>
        Le marchand devra compléter ou mettre à jour ses informations KYC afin de réactiver pleinement son compte et retrouver l’ensemble de ses fonctionnalités.
      </div>
    </>
  ) : (
    <p>
      Cette action rendra le KYC actif dans l’environnement de production.
      Il pourra désormais reprendre ses activités.
    </p>
  )}
</div>
<div style={{display: "flex",justifyContent: "center",alignItems: "center" }}>
                  <img
                    src={selectedMerchent?.profilePhoto ||defaultAvatar}
                       alt={`${selectedMerchent?.firstName} ${selectedMerchent?.lastName}`}
                        style={{
                            width: 46,
                            height: 46,
                            borderRadius: "50%",
                            objectFit: "cover"
                        }}
                        />
                  </div>
                    </div>
        < span className="merchent">{selectedMerchent?.firstName} {selectedMerchent?.lastName}</span>
        <div className="merchente">Marchand</div>
        <div className="validate-description">
          {!isKycActive ? (
            <>
              <p>Êtes-vous sûr de vouloir activer le kyc de ce marchant ?</p>
            </>
          ) : (
            <>
              <p>Voulez-vous vraiment désactiver le kyc de ce marchant ?</p>
               <div style={{ marginTop: "15px" }}>
              <label style={{ fontWeight: 400 ,fontSize:'13px',fontFamily:'Poppins',color:'#6A6A6A',display:'flex',textAlign:'left'}}>Motif de désactivation du kyc <span style={{color:"red"}}>*</span></label>
              <Input.TextArea
                placeholder="Message au marchand (sera envoyé par email)."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                rows={4}
                style={{ marginTop: "6px", borderRadius: "8px",fontWeight: 400 ,fontSize:'13px',fontFamily:'Poppins',color:'#B7B7B7' }}
              />
            </div>
            </>
          )}
         
        </div>
 <div className="validate-footer mb-2">
        <button
        style={{
                  backgroundColor: !isKycActive ? " #EBFFEA" : " #FFF0F0",
                  color: !isKycActive ? " #349C32 " : " #D41C1C",
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"80%"
                }}
//disabled={isLoadingSubmit || (isKycActive && !reason.trim())}
            onClick={handleAction}
            loading={isLoadingSubmit}
          >
            {isLoadingSubmit
              ? !isKycActive
                ? "Validation en cours..."
                : "Désactivation..."
              : !isKycActive
                ? "Confirmer l'activation"
                : "Confirmer la désactivation"}
          </button>
          </div>
           <button
           style={{
                  backgroundColor:'#F3F3F3',
                  color: '#000000',
                  padding: "5px 12px",
                  fontFamily: "Poppins",
                  fontWeight: 400,
                  fontSize: "14px",
                  borderRadius: "8px",
                  border: "none",
                  outline: "none",
                  cursor: "pointer",
                  width:"80%"
                }}
           onClick={() => setModal(false)} disabled={isLoadingSubmit}>
            Annuler
          </button>
      </div>
    </Modal>
  );
};

export default KycMerchent;
